import { RequestPayload, ResponseData, SuccessResponseDTO } from '../../dtos/generic'
import { ResourceDTO } from '../../dtos/resources'
import { defineRoute } from '../new-helpers'
import { adminControllerPath } from './admin'

export const adminResourcesControllerPath = adminControllerPath + 'resources/'

export const AdminResourcesRoutes = {
  createOne: defineRoute<'POST', ResponseData<ResourceDTO>, RequestPayload<Pick<ResourceDTO, 'content' | 'title'>>>({
    path: adminResourcesControllerPath,
  }),

  restoreOne: defineRoute<'GET', ResponseData<ResourceDTO>>({
    path: `${adminResourcesControllerPath}:resourceId`,
  }),

  deleteOne: defineRoute<'DELETE', ResponseData<SuccessResponseDTO>>({
    path: `${adminResourcesControllerPath}:resourceId`,
  }),

  updateOne: defineRoute<
    'PATCH',
    ResponseData<ResourceDTO>,
    RequestPayload<Partial<Pick<ResourceDTO, 'content' | 'title'>>>
  >({
    path: `${adminResourcesControllerPath}:resourceId`,
  }),

  getAll: defineRoute<'GET', ResponseData<ResourceDTO[]>>({
    path: adminResourcesControllerPath,
  }),
}
